var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.099,
    height: 17.79,
    viewBox: "0 0 18.099 17.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-airplane",
    "data-name": "Icon metro-airplane",
    d: "M16.145,13.046,12.914,9.87,20.67,4.152,18.407,1.928,8.712,5.74l-3.052-3c-.88-.865-2.109-1.072-2.731-.461S2.518,4.1,3.4,4.964l3.052,3-3.879,9.53,2.262,2.224,5.818-7.624,3.231,3.176v4.447h2.262l1.131-3.335,3.393-1.112V13.046H16.145Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#716f6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.9a411767f0439e65b1c0c21cf1caabaa.svg";
export { ForwardRef as ReactComponent };